import AccountDocumentsTab from ".././accounts-documents/AccountDocumentsTab";

export default function DocumentsTab({lead_id}){

    return(
        <>
        <div className="p-4">
            <div className="w-full flex flex-col p-4 bg-white rounded-lg item-start mb-4">
                <h2 className="py-2 font-bold mb-4 text-xl">Insurance Documents</h2>
            </div>
        </div>
        <AccountDocumentsTab lead_id = {lead_id}/>
        </>
        
    )
}
